<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h3>Vimeo</h3>
          <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="video" size="lg" [fixedWidth]="true"></fa-icon>
        </div>
        <div class="card-body">
          <app-vimeo-explorer [edit]="true"></app-vimeo-explorer>
        </div>
      </div>
    </div>
  </div>
</div>
